import { ITranslationEntry } from '../lang';

export const DE: ITranslationEntry = {
  translations: {
    notifications: 'Benachrichtigungen',
    markAllAsRead: 'Alle als gelesen markieren',
    poweredBy: 'von',
    settings: 'Einstellungen',
  },
  lang: 'de',
};
